"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  viewBox: "0.00 0.00 311.00 320.00",
  width: "24",
  height: "24",
  className: "lucide lucide-google-chat"
}, props), /*#__PURE__*/React.createElement("g", {
  strokeWidth: "2.00",
  fill: "none",
  strokeLinecap: "butt"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#7e916f",
  vectorEffect: "non-scaling-stroke",
  d: "M 76.37 0.51 L 76.38 76.98"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1375eb",
  vectorEffect: "non-scaling-stroke",
  d: "M 76.38 76.98 L 0.00 76.96"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#f3801d",
  vectorEffect: "non-scaling-stroke",
  d: "M 235.08 1.09 Q 234.92 1.15 234.81 1.22 Q 234.64 1.31 234.64 1.50 L 234.62 77.01"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#7eb426",
  vectorEffect: "non-scaling-stroke",
  d: "M 234.62 77.01 Q 234.60 77.01 234.57 77.01"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#91a080",
  vectorEffect: "non-scaling-stroke",
  d: "M 76.41 77.01 Q 76.40 77.00 76.38 76.98"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#75783e",
  vectorEffect: "non-scaling-stroke",
  d: "M 310.53 76.77 L 234.62 77.01"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#138495",
  vectorEffect: "non-scaling-stroke",
  d: "M 76.43 182.69 L 0.00 182.67"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#00983a",
  vectorEffect: "non-scaling-stroke",
  d: "M 76.44 259.13 L 76.43 220.85"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0066da",
  d: "M 76.37 0.51 L 76.38 76.98 L 0.00 76.96 L 0.00 20.77 Q 0.85 14.81 3.53 10.76 Q 10.14 0.74 22.75 0.67 Q 49.41 0.53 76.37 0.51 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fbbc04",
  d: "M 76.37 0.51 L 233.79 0.53 A 1.61 1.57 -26.7 0 1 234.71 0.82 L 235.08 1.09 Q 234.92 1.15 234.81 1.22 Q 234.64 1.31 234.64 1.50 L 234.62 77.01 Q 234.60 77.01 234.57 77.01 L 76.41 77.01 Q 76.40 77.00 76.38 76.98 L 76.37 0.51 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ea4335",
  d: "M 235.08 1.09 L 310.53 76.77 L 234.62 77.01 L 234.64 1.50 Q 234.64 1.31 234.81 1.22 Q 234.92 1.15 235.08 1.09 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2684fc",
  d: "M 0.00 76.96 L 76.38 76.98 Q 76.40 77.00 76.41 77.01 L 76.43 182.69 L 0.00 182.67 L 0.00 76.96 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00ac47",
  d: "M 310.53 76.77 L 311.00 77.11 L 311.00 239.01 Q 308.34 253.54 295.94 257.78 Q 291.52 259.30 282.91 259.28 Q 227.02 259.19 169.99 259.11 Q 161.71 259.10 153.19 259.23 Q 152.72 259.24 152.39 259.57 Q 124.49 287.34 96.39 315.59 C 93.52 318.48 90.27 320.09 86.15 319.48 Q 80.39 318.63 77.66 313.54 Q 76.51 311.38 76.49 305.66 Q 76.42 282.47 76.44 259.13 L 76.43 220.85 L 114.21 183.07 A 1.79 1.77 22.3 0 1 115.47 182.55 L 233.77 182.59 A 0.83 0.83 0.0 0 0 234.60 181.76 L 234.57 77.01 Q 234.60 77.01 234.62 77.01 L 310.53 76.77 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00832d",
  d: "M 76.43 182.69 L 76.43 220.85 L 76.44 259.13 Q 52.47 259.27 28.91 259.22 Q 19.09 259.20 14.76 257.68 Q 2.62 253.44 0.00 238.88 L 0.00 182.67 L 76.43 182.69 Z"
}));
var _default = exports.default = SvgComponent;